import React from "react";
import type { School } from "../types/team";
import { initials } from "../utils/progress";
interface AvatarProps {
  name: string;
  school?: School | "mentor";
  photo?: string;
  size?: "sm" | "md" | "lg" | "xl";
}
const sizes = {
  sm: "h-7 w-7 text-[11px]",
  md: "h-9 w-9 text-xs",
  lg: "h-12 w-12 text-sm",
  xl: "h-24 w-24 text-2xl"
};
const tones = {
  link: "bg-link-soft text-link",
  mahindra: "bg-saffron-soft text-saffron-ink",
  mentor: "bg-navy text-white"
};
export function Avatar({
  name,
  school = "mentor",
  photo,
  size = "md"
}: AvatarProps) {
  if (photo) {
    return <img src={photo} alt="" className={`shrink-0 rounded-full object-cover ${sizes[size]}`} aria-hidden="true" data-id="element-29" data-mp="gwxerkcc63rl" />;
  }
  return <span className={`inline-flex shrink-0 items-center justify-center rounded-full font-bold ${sizes[size]} ${tones[school]}`} aria-hidden="true" data-id="element-30" data-mp="2iojyr1xt8yek">
      {initials(name || "?")}
    </span>;
}